/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
var jQuery = require('jquery')
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

export const rails_ujs = require("@rails/ujs");

const images = require.context('../images', true)
import "bootstrap";
import "@fortawesome/fontawesome-pro/css/all.css";

// Metronic/Sass/Style
import '../src/metronic/sass/style';

require("chartkick/chart.js"); 

// Metronic/Js/Components
window.KTUtil       = require('../src/metronic/js/components/util.js');
window.KTApp        = require('../src/metronic/js/components/app.js');
window.KTHeader     = require('../src/metronic/js/components/header.js');
window.KTMenu       = require('../src/metronic/js/components/menu.js');
window.KTOffcanvas  = require('../src/metronic/js/components/offcanvas.js');
window.KTToggle     = require('../src/metronic/js/components/toggle.js');
// window.KTWizard     = require('../src/metronic/js/components/wizard.js');

// Metronic/Js/Layout/Base
window.KTLayoutAsideMenu      = require('../src/metronic/js/layout/base/aside-menu.js');
window.KTLayoutAsideToggle    = require('../src/metronic/js/layout/base/aside-toggle.js');
window.KTLayoutAside          = require('../src/metronic/js/layout/base/aside.js');
window.KTLayoutHeaderMenu     = require('../src/metronic/js/layout/base/header-menu.js');
window.KTLayoutHeaderTopbar   = require('../src/metronic/js/layout/base/header-topbar.js');
window.KTLayoutHeader         = require('../src/metronic/js/layout/base/header.js');
window.KTLayoutSubheader      = require('../src/metronic/js/layout/base/subheader.js');
window.KTLayoutContent        = require('../src/metronic/js/layout/base/content.js');
window.KTLayoutStretchedCard  = require('../src/metronic/js/layout/base/stretched-card.js');


// Using custom javascript library which is not available on npm
import "../src/vendors/plugins/select2/select2.min.js"
import "../src/vendors/plugins/select2/select2.min.css"

import "../src/vendors/plugins/jquery-slidePanel/jquery-slidePanel.min.js";
import "../src/vendors/plugins/jquery-slidePanel/slidePanel.min.css";
// import Sortable from 'sortablejs'
// window.Sortable = Sortable;
window.Sorttable = require('../src/custom/js/sorttable.js');
window.KTSlidePanel = require('../src/custom/js/slidePanel.js');
//window.Heremaps = require('../src/custom/js/heremaps.js');

import Swal from 'sweetalert2';
window.Swal = Swal;

// Metronic/Js/Layout/İnitialize.js
require('../src/metronic/js/layout/initialize.js');

require('../src/custom/js/trixAttachments.js');
window.MdCheckboxes = require('../src/custom/js/mdcheckboxes.js');

// Here maps
import "../src/custom/js/heremaps.js";

// Custom CSS
import '../src/custom/sass/style';

rails_ujs.start()
// require("turbolinks").start()
require("@rails/activestorage").start()
// require("channels")
